/* HS!/JPD — clothe the traced flat.
 *
 * snippets/hs-flat-jean.liquid draws the shop's real technical flat with a
 * generated silhouette behind the line art. This file only ever changes CSS
 * custom properties on that SVG, so it never touches geometry and can never
 * put a zone in the wrong place:
 *
 *   --hsf-cloth      base cloth colour
 *   --hsf-stitch     topstitch colour
 *   --hsf-hardware   rivet / button tone
 *   .is-swatch       swap the generated twill for a real cloth photo
 *
 * Inputs, all optional — whatever exists on the page is used:
 *   [data-hsb-fabric]:checked   builder fabric radio (+ data-fabric-config, data-swatch)
 *   [data-hsb-hwset]:checked    builder hardware set
 *   [data-hsb-thread], [data-hsc-thread]  thread swatch radios
 *
 * ZERO backslash literals in this file — the MCP deploy transport corrupts them.
 */
(function () {
  'use strict';

  // Local mirror of hs-jean-preview.js FABRICS, used only when that file is not
  // on the page (the customizer does not load it). When it IS loaded we read its
  // exported table instead, so the colours cannot drift apart.
  var FALLBACK_FABRICS = {
    BLACK:  { base: '#23242a', wash: 0.05 },
    WASHED: { base: '#6b8fc4', wash: 0.60 },
    HEAVY:  { base: '#263d67', wash: 0.00 },
    ECRU:   { base: '#ded3bb', wash: 0.20 },
    DEAD:   { base: '#3a5687', wash: 0.18 },
    RAW:    { base: '#2f4a7a', wash: 0.00 }
  };
  // Order matters: first hit wins, so the specific terms come before the general.
  var KEYWORDS = [
    ['BLACK', 'BLACK'], ['WASH', 'WASHED'], ['ECRU', 'ECRU'],
    ['DEADSTOCK', 'DEAD'], ['16OZ', 'HEAVY'], ['HEAVY', 'HEAVY']
  ];

  function parseJSON(raw) {
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function fabricTable() {
    var api = window.HSJeanPreview;
    return (api && api.FABRICS) ? api.FABRICS : FALLBACK_FABRICS;
  }

  function resolveFabric(input) {
    var table = fabricTable();
    if (!input) return table.RAW || FALLBACK_FABRICS.RAW;

    var cfg = parseJSON(input.getAttribute('data-fabric-config'));
    // An explicit Admin override always wins — a new fabric can carry its own hex.
    if (cfg && cfg.color) return { base: cfg.color, wash: cfg.wash || 0 };

    // Prefer the preview's own resolver when it is on the page.
    var api = window.HSJeanPreview;
    var title = input.getAttribute('data-title') || '';
    if (api && typeof api.pickFabric === 'function') {
      var f = api.pickFabric(title, cfg);
      if (f && f.base) return f;
    }

    var hay = (title + ' ' + (input.getAttribute('data-sku') || '')).toUpperCase();
    for (var i = 0; i < KEYWORDS.length; i++) {
      if (hay.indexOf(KEYWORDS[i][0]) !== -1) {
        return table[KEYWORDS[i][1]] || FALLBACK_FABRICS[KEYWORDS[i][1]];
      }
    }
    return table.RAW || FALLBACK_FABRICS.RAW;
  }

  function firstChecked(scope, sel) {
    var els = scope.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) { if (els[i].checked) return els[i]; }
    return null;
  }

  // A thread swatch carries its colour either as a value or on a child chip.
  function threadColour(scope) {
    var t = firstChecked(scope, '[data-hsb-thread], [data-hsc-thread] input, [data-hsf-thread]');
    if (!t) return null;
    var explicit = t.getAttribute('data-color');
    if (explicit) return explicit;
    var label = t.closest('label');
    // .hsc__opt-swatch is the customizer/builder thread chip; its colour is an
    // inline background-color, which is why an explicit data-color is preferred.
    var chip = label && label.querySelector('[data-color], .chip, .hsc__swatch-dot, .hsc__opt-swatch');
    if (chip) {
      var c = chip.getAttribute('data-color');
      if (c) return c;
      var bg = getComputedStyle(chip).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
    }
    return null;
  }

  var HW_TONE = {
    BRASS: '#d9b45a', COPPER: '#c9744a',
    NICKEL: '#c9ced6', SILVER: '#c9ced6',
    BLACK: '#2b2b31', OXIDE: '#2b2b31'
  };
  function hardwareTone(scope) {
    var h = firstChecked(scope, '[data-hsb-hwset]');
    if (!h) return null;
    var t = (h.getAttribute('data-title') || h.value || '').toUpperCase();
    for (var k in HW_TONE) { if (t.indexOf(k) !== -1) return HW_TONE[k]; }
    return null;
  }

  function clothe(svg, scope) {
    var fabricInput = firstChecked(scope, '[data-hsb-fabric]');
    var f = resolveFabric(fabricInput);

    svg.style.setProperty('--hsf-cloth', f.base);

    // A real swatch photo always beats the generated weave.
    var swatch = fabricInput && fabricInput.getAttribute('data-swatch');
    // Scoped to THIS svg and matched by class, not by a fixed id. Regenerated
    // flats name their swatch image per garment (hsf-swatch-img-tote) so two
    // flats in one document cannot collide; the legacy jean still carries the
    // bare id, so both spellings have to resolve.
    var img = svg.querySelector('.hsf__swatch-img') || svg.querySelector('[id^="hsf-swatch-img"]');
    if (swatch && img) {
      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', swatch);
      img.setAttribute('href', swatch);
      svg.classList.add('is-swatch');
    } else {
      svg.classList.remove('is-swatch');
    }

    var stitch = threadColour(scope);
    if (stitch) svg.style.setProperty('--hsf-stitch', stitch);

    var hw = hardwareTone(scope);
    if (hw) svg.style.setProperty('--hsf-hardware', hw);

    // Hardware is OPTIONAL on the tote, and a colour variable cannot express
    // absence - a hidden rivet is not a differently coloured rivet. Hide the HW
    // layer only when a hardware control exists AND it is explicitly NONE. When
    // a page carries no hardware control at all (the jean builder) the rivets
    // must keep rendering, so absence of the control is never treated as NONE.
    var hwPick = firstChecked(scope, '[data-hsb-hwset]');
    var hwName = hwPick ? (hwPick.getAttribute('data-title') || hwPick.value || '') : '';
    var noHw = !!hwPick && hwName.toUpperCase().indexOf('NONE') !== -1;
    svg.classList.toggle('is-nohw', noHw);

    // Ecru and heavily washed cloth need dark stitching to stay legible.
    var pale = f.wash >= 0.5 || /^#(d|e|f)/i.test(String(f.base));
    svg.classList.toggle('is-pale', !!pale);
  }

  function boot() {
    var svgs = document.querySelectorAll('.hsf__svg');
    if (!svgs.length) return;
    for (var i = 0; i < svgs.length; i++) {
      (function (svg) {
        var scope = svg.closest('.hs-customizer-section, .hs-builder-section, .hsdb, form, body') || document.body;
        clothe(svg, scope);
        scope.addEventListener('change', function () { clothe(svg, scope); });
      })(svgs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.HSFlatCloth = { boot: boot, clothe: clothe };
})();
